import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  DEFAULT_STATS_FILTER,
  parseGranularity,
  parseTimeRangeKey,
  type StatsFilter,
} from "./stats-time-filter";

const RANGE_PARAM = "range";
const VIEW_PARAM = "view";

export const useStatsFilter = (): [
  StatsFilter,
  (change: Partial<StatsFilter>) => void,
] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filter = useMemo(
    (): StatsFilter => ({
      range:
        parseTimeRangeKey(searchParams.get(RANGE_PARAM)) ??
        DEFAULT_STATS_FILTER.range,
      granularity:
        parseGranularity(searchParams.get(VIEW_PARAM)) ??
        DEFAULT_STATS_FILTER.granularity,
    }),
    [searchParams],
  );

  const setFilter = useCallback(
    (change: Partial<StatsFilter>) => {
      const next = new URLSearchParams(searchParams);
      if (change.range) next.set(RANGE_PARAM, change.range);
      if (change.granularity) next.set(VIEW_PARAM, change.granularity);
      setSearchParams(next);
    },
    [searchParams, setSearchParams],
  );

  return [filter, setFilter];
};
